export const fetchSearch = term => ({
  type: 'FETCH_SEARCH',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v2/products/autocomplete?term=${term}`
    }
  }
})

export const emptySearch = () => ({
  type: 'EMPTY_SEARCH'
})



// WEBPACK FOOTER //
// ./src/App/Header/Search/actions.js